<template>
  <div class="p_employee_content e_dtl_content">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead/>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>系统</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/departMember' }">组织架构</el-breadcrumb-item>
                <el-breadcrumb-item>查看员工</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p_employee_box" v-loading="tableLoading">
            <div class="p_employee_list">
                <p class="r_edit_title">基础信息</p>
                <div class="p_employee_form">
                    <div class="p_employee_item">
                        <p class="emp_txt">员工姓名</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.userName}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">手机号码</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.userTel}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">身份证</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.stridcard}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">员工编号</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.userNumber}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">员工类型</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.userlabelname}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">入职时间</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.dtEntryDate.replace('T',' ')}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">关联账号</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.mainuseridname}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">是否在职</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.strWorkState}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">离职时间</p>
                        <!-- //如果为离职状态，显示离职时间 -->
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.strWorkState=='离职'?ruleForm.userInfo.dtQuitDate.replace('T',' '):'无'}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">招聘电话</p>
                        <!-- //如果为离职状态，显示离职时间 -->
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.appleTel}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="p_employee_list">
                <p class="r_edit_title">部门信息</p>
                <div class="p_employee_form">
                    <div class="p_employee_item">
                        <p class="emp_txt">所属部门</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.Strorganname}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">上级主管</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.strtopusername}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">岗位</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.StationName}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">是否合伙人</p>
                        <div class="emp_form_txt">
                            {{ruleForm.userInfo.StrIspartner}}
                        </div>
                    </div>
                </div>
                <div class="p_employee_form p_employee_form01" v-for="(item,index) in ruleForm.postList" :key="index+'p'">
                    <div class="p_employee_item">
                        <p class="emp_txt">工作岗位{{index+1}}</p>
                        <div class="emp_form_txt">
                           {{item.strWorkJob}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">上级主管{{index+1}}</p>
                        <div class="emp_form_txt">
                            {{item.strtopusername}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">职能标签{{index+1}}</p>
                        <div class="emp_form_txt">
                            {{item.strJobfunclabel}}
                        </div>
                    </div>
                    <div class="p_employee_item">
                        <p class="emp_txt">时间占比{{index+1}}</p>
                        <div class="emp_form_txt">
                            {{item.strTimepro}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="p_employee_list">
                <p class="r_edit_title">特别授权</p>
                <div class="p_employee_form">
                    <div class="p_employee_item">
                        <p class="emp_txt">关联角色</p>
                        <div class="emp_dtl_box">
                            <span class="txts01">{{associatedRole}}</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="p_employee_form p_employee_form01">
                    <div class="p_employee_item">
                        <p class="emp_txt">额外权限</p>
                        <div class="emp_dtl_box"></div>
                    </div>
                </div>
                <div class="dtl_table">
                    <el-table class="post_list" border :data="tableData" style="width:100%">
                        <el-table-column align="center" label="序号" width="70px">
                            <template slot-scope="{$index}">
                                <span>{{Number($index) + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="模块" min-width="130px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                            <span>{{row.Strmkname}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="状态" min-width="110px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                            <span>{{row.Strtype}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="页面" min-width="140px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                            <span>{{row.Strtoppowername}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="按钮" min-width="140px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                            <span>{{row.Strpowername}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div> -->
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import xz from "@/common"
import moment from 'moment'
export default {
  name: "updatePost",
  data() {
    return {
        ruleForm: {
            userInfo: {
            mainuserid: "",
            mainuseridname:'',
            newuserid: "", //用户id
            userTel: "", //手机号
            userName: "", //姓名
            userNumber: "", //编号（新增不用传）
            stridcard: "", //身份证
            strJobfunclabel: "", //岗位职能标签（传id）
            strJobfunclabel1: "",
            strJobfunclabel2: "",
            strJobfunclabel3: "",
            strTimepro: "", //时间占比
            strTimepro1: "",
            strTimepro2: "",
            strTimepro3: "",
            strtopuserid: "", //上级领导 必传
            strtopuserid1: "", //上级领导1
            strtopuserid2: "",
            strtopuserid3: "",
            strtopuserid4: "",
            strWorkJob: "", //工作岗位
            strWorkJob1: "",
            strWorkJob2: "",
            strWorkJob3: "",
            strWorkState: "在职", //在离职
            StrIspartner: "否", //是否合伙人
            dtEntryDate: "", //入职时间
            rolelabel: "", //角色标签
            dtQuitDate: "1900-01-01", //离职时间（没有传1900-01-01）
            struserdist: "", //区分
            userPwd: "", //密码
            userlabelid: "", //员工类型id
            userlabelname: "", //员工标签名称
            Strorgancode: "", //部门code
            Strorganname:'',
            organcodeVal:[],
            Strstation: "", //岗位id
            StrSecLevel: "", //安全级别
            StrRank: "", //职级
            StationName:'',//岗位名称
            strtopusername:'',//上级主管
            strtopusername1:'',//上级主管
            strtopusername2:'',
            strtopusername3:'',
            strtopusername4:''
            },
            postList: [
                {
                    strWorkJob: "",
                    strJobfunclabel: "",
                    strtopusername: "",
                    strTimepro: ""
                }
            ]
        },
        // 关联角色
        associatedRole:'',
        tableLoading:false,
        isEdit:'dtl',
        // 详情参数
        dtlQuery:{
            mainuserid:'',
            useridr:''
        },
        tableData:[]
    }
  },
  created() {
    this.isEdit = this.$route.query.isEdit
    this.dtlQuery.useridr = this.$route.query.id
    this.dtlQuery.mainuserid = this.$route.query.mainuserid
    this.getMemberDtl()
  },
  methods: {
      // 人员详情
    getMemberDtl() {
      let that = this
      this.tableLoading = true
      xz.getauthJbUserDetail(this.dtlQuery).then((res) => {
        // console.log('res',res)
        if (res.status == "ok") {
          let resmsg = res.msg
        //   let res1 = res.inforoledist
        //   if(JSON.stringify(res1) == '{}'){
        //       this.tableData = []
        //   }else{
        //       this.tableData = res1
        //   }
          this.ruleForm.userInfo.mainuserid = resmsg.Mainuserid;
          this.ruleForm.userInfo.mainuseridname = resmsg.Mainuseridname;
          this.ruleForm.userInfo.newuserid = resmsg.Userid;
          this.ruleForm.userInfo.userTel = resmsg.Strmobile;
          this.ruleForm.userInfo.userName = resmsg.Username;
          this.ruleForm.userInfo.userNumber = resmsg.UserNumber;
          this.ruleForm.userInfo.stridcard = resmsg.Stridcard;
          this.ruleForm.userInfo.strJobfunclabel = resmsg.StrJobfunclabel;
          this.ruleForm.userInfo.strJobfunclabel1 = resmsg.StrJobfunclabel1;
          this.ruleForm.userInfo.strJobfunclabel2 = resmsg.StrJobfunclabel2;
          this.ruleForm.userInfo.strJobfunclabel3 = resmsg.StrJobfunclabel3;
          this.ruleForm.userInfo.strTimepro = resmsg.StrTimepro;
          this.ruleForm.userInfo.strTimepro1 = resmsg.StrTimepro1;
          this.ruleForm.userInfo.strTimepro2 = resmsg.StrTimepro2;
          this.ruleForm.userInfo.strTimepro3 = resmsg.StrTimepro3;
          this.ruleForm.userInfo.strtopuserid = resmsg.Strtopuserid;
          this.ruleForm.userInfo.strtopuserid1 = resmsg.Strtopuserid1;
          this.ruleForm.userInfo.strtopuserid2 = resmsg.Strtopuserid2;
          this.ruleForm.userInfo.strtopuserid3 = resmsg.Strtopuserid3;
          this.ruleForm.userInfo.strtopuserid4 = resmsg.Strtopuserid4;
          this.ruleForm.userInfo.strWorkJob = resmsg.StrWorkJob;
          this.ruleForm.userInfo.strWorkJob1 = resmsg.StrWorkJob1;
          this.ruleForm.userInfo.strWorkJob2 = resmsg.StrWorkJob2;
          this.ruleForm.userInfo.strWorkJob3 = resmsg.StrWorkJob3;
          this.ruleForm.userInfo.strWorkState = resmsg.StrWorkState;
          this.ruleForm.userInfo.appleTel = resmsg.AppleTel;
          this.ruleForm.userInfo.StrIspartner = resmsg.StrIspartner;
          this.ruleForm.userInfo.dtEntryDate = resmsg.DtEntryDate;
          this.ruleForm.userInfo.rolelabel = resmsg.Rolelabel;
          this.ruleForm.userInfo.dtQuitDate = resmsg.DtQuitDate;
          this.ruleForm.userInfo.struserdist = resmsg.UserNumber.substring(0, 1);
          this.ruleForm.userInfo.userPwd = '';
          this.ruleForm.userInfo.userlabelid = resmsg.Userlabelid;
          this.ruleForm.userInfo.userlabelname = resmsg.Userlabelname;
          this.ruleForm.userInfo.Strorgancode = resmsg.Strorgancode;
          this.ruleForm.userInfo.Strorganname = resmsg.Strorganname
          this.ruleForm.userInfo.Strstation = resmsg.Strstation;
          this.ruleForm.userInfo.StrSecLevel = resmsg.StrSecLevel;
          this.ruleForm.userInfo.StrRank = resmsg.StrRank;
          this.ruleForm.userInfo.StationName = resmsg.StationName //岗位名称
          this.ruleForm.userInfo.strtopusername = resmsg.strtopusername //上级主管
          this.ruleForm.userInfo.strtopusername1 = resmsg.strtopusername1 //上级主管
          this.ruleForm.userInfo.strtopusername2 = resmsg.strtopusername2 //上级主管
          this.ruleForm.userInfo.strtopusername3 = resmsg.strtopusername3 //上级主管
          this.ruleForm.userInfo.strtopusername4 = resmsg.strtopusername4 //上级主管
          if(resmsg.Strroletypesname.indexOf('系统出错')>-1){
            this.associatedRole = ''
          }else{
            this.associatedRole = resmsg.Strroletypesname
          }
          this.ruleForm.postList = [
            {
              strWorkJob: resmsg.StrWorkJob,
              strJobfunclabel: resmsg.StrJobfunclabelname,
              strtopusername: resmsg.strtopusername1,
              strTimepro: resmsg.StrTimepro
            },
            {
              strWorkJob: resmsg.StrWorkJob1,
              strJobfunclabel: resmsg.StrJobfunclabelname1,
              strtopusername: resmsg.strtopusername2,
              strTimepro: resmsg.StrTimepro1
            },
            {
              strWorkJob: resmsg.StrWorkJob2,
              strJobfunclabel: resmsg.StrJobfunclabelname2,
              strtopusername: resmsg.strtopusername3,
              strTimepro: resmsg.StrTimepro2
            },
            {
              strWorkJob: resmsg.StrWorkJob3,
              strJobfunclabel: resmsg.StrJobfunclabelname3,
              strtopusername: resmsg.strtopusername4,
              strTimepro: resmsg.StrTimepro3
            }
          ]
          // 去除非空对象
          let filteredArr = this.ruleForm.postList.filter((obj) => {
            return !(this.isNull(obj.strWorkJob));
          });
            this.ruleForm.postList = filteredArr
        } else {
          console.log('获取详情出错')
        }
        this.tableLoading = false
      });
    },
    // 取消
    backHandle(){
        this.$router.push({
            path: "/postManage",
        });
    },
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN'
    }
  }
}
</script>
<style scoped>
.dtl_table{
    padding-left: 15px;
    box-sizing: border-box;
}
.r_edit_title{
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color:#000;
    border-bottom: 1px solid #DCDFE6;
}
.emp_form_txt{
    width: 370px;
    font-size: 14px;
    color: #000;
}
.emp_form_txt_num.emp_form_txt{
    width: 130px;
}
.p_employee_top{
    margin: 10px 0;
}
.emp_dtl_box{
    padding-left: 10px;
    flex: 1;
}
.emp_dtls{
    cursor: pointer;
    color:#19bd92;
    font-size: 14px;
}
.txts01{
    font-size: 14px;
}
.p_employee_item{
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 3px;
}
.p_employee_form.p_employee_form01{
    margin-top: 0;
}
.p_employee_form{
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
}
.emp_txt{
    width: 82px;
    text-align: right;
    font-size: 14px;
    color: #999;
    padding: 0 10px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.p_btn_box{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.p_employee_box{
    background-color: #fff;
    padding: 15px 10px;
}
</style>
<style>
.e_dtl_content .el-table .el-table__cell{
    padding: 4px 0;
}
</style>